/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2021 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Button } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { CarrierManagementSubMenuItems } from "./CarrierManagementContainer";

const StyledLinkButton = styled(({ theme, ...props }) => <Button {...props} />)`
  color: ${(props) => props.theme.palette.common.white} !important;
  :hover {
    text-decoration: underline !important;
  }
  text-transform: capitalize !important;
`;

const CarrierManagementSubMenu = (props) => {
  const { setPanel } = props;
  const theme = useTheme();

  return (
    <>
      <StyledLinkButton
        theme={theme}
        onClick={() => setPanel(CarrierManagementSubMenuItems.CARRIER_SEARCH)}
        data-testid="btn-carrier-search"
      >
        Carrier Search
      </StyledLinkButton>
      <StyledLinkButton
        theme={theme}
        onClick={() => setPanel(CarrierManagementSubMenuItems.TIER_SETTINGS)}
        data-testid="btn-tier-settings"
      >
        Tier Settings
      </StyledLinkButton>
    </>
  );
};

CarrierManagementSubMenu.propTypes = {
  setPanel: PropTypes.func.isRequired,
};

export default CarrierManagementSubMenu;
